// extracted by mini-css-extract-plugin
export default {"wrapper":"Du-z","button":"Eu-z","alternate":"Fu-z","disabled":"Gu-z","paymentWarning":"Hu-z","fadeIn":"Iu-z"};